// src/components/DarkModeSwitch.js

import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { Sun, Moon } from 'react-bootstrap-icons';
import { SettingsContext } from '../contexts/SettingsContext';
import { LanguageContext } from '../contexts/LanguageContext';

const DarkModeSwitch = () => {
  const { settings, updateSettings } = useContext(SettingsContext);
  const { translations } = useContext(LanguageContext);

  const toggleTheme = () => {
    const newTheme = settings.theme === 'dark' ? 'light' : 'dark';
    updateSettings({ theme: newTheme });
  };

  return (
    <Button 
      variant="secondary" 
      onClick={toggleTheme} 
      aria-label={translations.darkMode}
      className="d-flex align-items-center"
    >
      {settings.theme === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
      <span className="d-none d-md-inline ms-1">
        {settings.theme === 'dark' ? translations.lightMode || 'Light' : translations.darkMode || 'Dark'}
      </span>
    </Button>
  );
};

export default React.memo(DarkModeSwitch);
